export default "__VITE_ASSET__819d1a10__"